import { range } from "lodash";
import { createResource } from "@evergis/react-fetching";

import {
  AttributeDistinctDc,
  AttributeType,
  ClassifyAttributeType,
  ClassifyParams2,
  GetClassifyDc,
} from "@evergis/api";

import { unEscapeAttributeValue } from "../modules/FeatureCard/hooks/useFeatureAttributes";
import { isNumberAttribute } from "../interfaces/service";

import { api as evergisApi } from "../evergis/api";
import { ClassificationType } from "../interfaces/classification";

export const checkEmpty = ({ value }: AttributeDistinctDc): boolean => value !== "";

export type ClassifyInput = {
  params?: ClassifyParams2;
  type?: ClassificationType;
  attributeType?: AttributeType;
  minQuantity?: number;
  maxQuantity?: number;
};

export const layerClassified = createResource(
  ({ type, params, attributeType, minQuantity, maxQuantity }: ClassifyInput = {}) =>
    async api => {
      if (minQuantity && maxQuantity) {
        return {
          data: [
            ...range(minQuantity, maxQuantity, Math.floor((maxQuantity - minQuantity) / params.classes)),
            maxQuantity,
          ],
        };
      }

      let values: number[] | string[];

      // TODO wait input not works for refetching with undefined
      if (type === undefined || params === undefined) {
        return {
          data: undefined,
        };
      }

      if (isNumberAttribute(attributeType)) {
        values = (await api.statistic.classify(params)).classifyResult.map(({ value }) => value);
      } else if (attributeType === AttributeType.String) {
        values = (
          await api.statistic.classify({ ...params, attributeType: ClassifyAttributeType.Text })
        ).classifyResult.map(({ value }) => unEscapeAttributeValue(value));
      } else if (attributeType === AttributeType.DateTime) {
        const distinctResponse = await api.statistic.classify({
          ...params,
          attributeType: ClassifyAttributeType.DateTime,
        });
        const distincts = distinctResponse.classifyResult.filter(checkEmpty) as AttributeDistinctDc[];

        values = distincts.map(({ value }) => unEscapeAttributeValue(value));
      }

      return {
        data: values,
      };
    },
  { injected: evergisApi },
);

export const getClassify = createResource(
  (params: ClassifyParams2) => async api => ({
    data: await api.statistic.classify(params),
  }),
  {
    injected: evergisApi,
  },
);

export const getClassifyPost = createResource(
  (params: GetClassifyDc) => async api => ({
    data: await api.statistic.postClassify(params),
  }),
  {
    injected: evergisApi,
  },
);
